import "./App.css";
import { Routes, Route, BrowserRouter } from "react-router-dom";
import Login from "./Pages/Login";
import MachineList from "./Pages/MachineList";
import "leaflet/dist/leaflet.css";

import Home from "./Pages/Home";
import MachineListMap from "./Pages/MachineListMap";
import Dashboard from "./Pages/Dashboard";
import { useState } from "react";
import UserContext from "./UseContext/UserContext";
import Report from "./Pages/Report";
import ConsuptionDashboard from "./Pages/ConsuptionDashboard";
import Dashboard2 from "./Pages/Dashboard2";

function App() {
  const [drawer, setDrawer] = useState("miniclose");

  window.addEventListener("popstate", () => {
    window.location.reload();
  });

  return (
    // <AuthProvider>
    <BrowserRouter>
      <UserContext.Provider value={{ drawer, setDrawer }}>
        <Routes>
          <Route exact path='/' element={<Login />} />
          <Route exact path='/Home' element={<Home />} />
          <Route exact path='/MachineList' element={<MachineList />} />
          <Route exact path='/MachineListMap' element={<MachineListMap />} />
          <Route exact path='/Dashboard' element={<Dashboard2 />} />
          <Route
            exact
            path='/ConsuptionDashboard'
            element={<ConsuptionDashboard />}
          />
          <Route exact path='/Report' element={<Report />} />
        </Routes>
      </UserContext.Provider>
    </BrowserRouter>
    // </AuthProvider>
  );
}

export default App;
